import { useAppDispatch } from 'src/store'
import { squareChangeCard } from 'src/useCase/paymentInfo'

export type FormValues = {
  source_id: string
  verification_token?: string
}
export const usePayment = () => {
  const dispatch = useAppDispatch()

  const onCharge = async (tokenResult: {
    status: string
    token: string
    verification_token?: string
  }) => {
    const { status, token, verification_token } = tokenResult
    if (status === 'OK') {
      const params: FormValues = {
        source_id: token,
        verification_token,
      }
      await dispatch(squareChangeCard(params))
    }
  }

  return {
    onCharge,
  }
}
